import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/configs')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/config' })
  },
})
